import React from 'react';
import GridContainer from '../../../../Grid/GridContainer';
import GridItem from '../../../../Grid/GridItem';
import Button from '../../../../CustomButtons/Button';
import TransferMap from '../TransferMap';

const TransferMapSection = ({
  customer,
  event,
  state,
  getStatus,
  handleToPDF,
  canAssignDriver,
  t
}: any) => {
  return (
    <>
      <div style={{ width: '100%' }}>
        <TransferMap
          googleMapURL="/googlemap"
          loadingElement={<div style={{ height: `100%` }} />}
          containerElement={
            <div
              style={{
                height: `500px`,
                overflow: "hidden",
                borderRadius: "6px",
                width: `100%`,
              }}
            />
          }
          mapElement={<div style={{ height: `100%` }} />}
          center={customer}
          customer={customer}
          nosocomio={event?.origin?.transferItemRequestId?.hospital}
          currentPosition={state.currentPosition}
          directions={state.directions}
          colorStroke={"#01abc2"}
          mode={"large"}
        />
      </div>
      <GridContainer style={{ textAlign: "right" }}>
        <GridItem xs={12} sm={12} md={12}>
          {getStatus() === "DONE" && (
            <Button
              onClick={handleToPDF}
              color="warning"
              style={{ textAlign: "right" }}
            >
              {t('download.document.pdf')}
            </Button>
          )}
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          {canAssignDriver() && (
            <Button
              onClick={() => {}}
              color="primary"
            >
              {t('service.driver.assign')}
            </Button>
          )}
        </GridItem>
      </GridContainer>
    </>
  );
};

export default TransferMapSection; 